import { getUID, setEventLogConfig } from '@/utils';
import { collectLogData, collectPlayCount } from '@/services/program';
import { getEventLogConfig } from '@/services/app';
import validator from '@/utils/validator';

/**
 * 检查打点路径是否为空
 * @param logPath
 * @returns {boolean}
 */
function checkIsEmptyLogPath(logPath) {
  return !logPath || logPath === '';
}

function getAppLogConfig() {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await getEventLogConfig();
      setEventLogConfig(data);
      return resolve(data);
    } catch (e) {
      return reject(e);
    }
  });
}

class PlayerLog {
  constructor(options) {
    const { logUrl } = options;
    this.logUrl = logUrl;
  }

  async validatorLogUrl() {
    const { logUrl } = this;
    if (validator.isEmptyObj(logUrl) || logUrl == null) {
      const res = await getAppLogConfig();
      const { logUrl: path } = res;
      this.logUrl = path;
      this.logUrl = path;
    }
  }

  logPlayCount(id, type, audioId) {
    return new Promise(async (resolve, reject) => {
      if (id <= 0) return reject(new Error(`logPlayCount get id: ${id}`));
      await this.validatorLogUrl();
      const { logUrl } = this;
      // 设置打点位置
      const logPath = logUrl[type].playCount;
      if (!checkIsEmptyLogPath(logPath)) {
        // 获取用户ID
        const userId = Number(getUID());
        const params = {
          audioId,
          id,
          userId,
        };
        try {
          const res = await collectPlayCount(logPath, params);
          return resolve(res);
        } catch (e) {
          return reject(e);
        }
      }
      return reject(new Error(`empty log path with ${logPath}`));
    });
  }

  logPlayProgress(id, data) {
    return new Promise(async (resolve, reject) => {
      if (id <= 0) return reject(new Error(`logPlayProgress get id: ${id}`));
      await this.validatorLogUrl();
      const { logUrl } = this;
      // 设置打点位置
      const { range: logPath } = logUrl;
      if (!checkIsEmptyLogPath(logPath)) {
        // 获取用户ID
        const userId = Number(getUID());
        // 组装数据
        const params = Object.assign({}, data, {
          userId,
          version: 'V1',
        });
        try {
          const res = await collectLogData(logPath, params);
          return resolve(res);
        } catch (e) {
          return reject(e);
        }
      }
      return reject(new Error(`empty log path with ${logPath}`));
    });
  }
}

export default PlayerLog;
